<template>
    <div style="background-color: #f2f2f2;height: 100%;">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            用药排班
        </div>
        <div style="padding: 20px;">

            <div class="BerthPage">

                <el-row>
                    <el-button type="primary" :disabled="disabledAdd" @click.native="toggleModalAdd">添加</el-button>
                    <el-button type="success" :disabled="disabledEdit" @click="handleEdit">编辑</el-button> 
                    <div style="float:right">
                        <el-input  placeholder="请输入老人姓名" v-model="elderlyName" clearable style="margin:0 10px;width:200px"></el-input>
                        <el-select
                            v-model="status"
                            style="margin:0 10px;width:200px"
                            placeholder="请选择状态">
                            <el-option
                                v-for="(item,i) in statusValue"
                                :key="i"
                                :label="item"
                                :value="i">
                            </el-option>
                        </el-select>
                        <el-date-picker
                            v-model="startTime"
                            type="date"
                            style="margin-right:10px;"
                            value-format="yyyy-MM-dd"
                            placeholder="开始日期" class="search">
                        </el-date-picker>
                        <el-date-picker
                            v-model="endTime"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="结束日期" class="search">
                        </el-date-picker>
                        <el-button style="margin-left:10px;float:right" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
                    </div>
                </el-row>

                <div style="clear: both;"></div>
            </div>

            <div style="height: 10px;"></div>

            <div>
                <template>

                    <el-table :data="tableData" :height="th" highlight-current-row @row-click="rowClick" border style="width: 100%;" default-expand-all>
                        <el-table-column type="expand" v-if="tableData.length">
                            <template slot-scope="props">
                                <el-form label-position="left" inline class="demo-table-expand">
                                    <el-form-item label="早晨用药：" v-if="props.row.medicationSchedulingMorningDTO">
                                        <el-tag v-for="(value,i) in props.row.medicationSchedulingMorningDTO.medicationSchedulingMorningItemList" :key="i" >{{value.name}}</el-tag>
                                    </el-form-item>
                                    <el-form-item label="中午用药：" v-if="props.row.medicationSchedulingNoonDTO">
                                        <el-tag v-for="(value,i) in props.row.medicationSchedulingNoonDTO.medicationSchedulingNoonItemList" :key="i" >{{value.name}}</el-tag>
                                    </el-form-item>
                                    <el-form-item label="晚上用药：" v-if="props.row.medicationSchedulingNightDTO">
                                        <el-tag v-for="(value,i) in props.row.medicationSchedulingNightDTO.medicationSchedulingNightItemList" :key="i" >{{value.name}}</el-tag>
                                    </el-form-item>
                                </el-form>
                            </template>
                        </el-table-column>
                        <el-table-column prop="elderlyName" label="老人姓名"></el-table-column>
                        <el-table-column prop="day" label="星期"></el-table-column>
                        <el-table-column prop="time" :formatter="getTime" label="用药日期"></el-table-column>

                        <!-- <el-table-column prop="name" label="用药组名称"></el-table-column> -->

                        <el-table-column
                                prop="Status"
                                :formatter="statusTitle"
                                label="状态">
                        </el-table-column>
                    </el-table>

                    <div style="text-align: left;background-color: #fff;padding: 10px;">
                        <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                        <div style="float: left;">
                            <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    :total="totalItems"
                                    :page-size="20"
                                    @current-change="current_change">
                            </el-pagination>
                        </div>
                        <div style="clear: both;"></div>
                    </div>


                </template>
            </div>

        </div>

        <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>
        <Edit ref="myEdit" v-show="showModalEdit" v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit>
        <GetElderly ref="myGetElderly" v-show="showModalGetElderly" v-on:closeGetElderly="closeGetElderly" v-on:openAdd="openAdd"></GetElderly>

    </div>
</template>

<script>
    import Add from "./Add";
    import Edit from "./Edit";
    import GetElderly from "./GetElderly";
    import {timeStr,timefilters,getBeforeDate} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode,getMenuButton} from "@/utils/auth";

    export default {
        name: "Page",
        data(){
            return{
                loading:false,
                showModalAdd:false,
                showModalEdit:false,
                disabledEdit:true,
                showModalGetElderly:false,
                menuButtonList:null,
                disabledAdd:true,
                datetimerangeValue:'',
                tableData:[],
                row:null,
                startTime:getBeforeDate(-30),
                endTime:getBeforeDate(0),
                totalItems: 0,
                pageSize:20,
                currentPage:1,
                status:0,
                elderlyName:'',
                statusValue:['药品排班状态','正常','禁用'],
                th:0,
                options:[]
            }
        },
        components:{
            Add,GetElderly,Edit
        },
        created(){
            this.init();
            this.getMenu();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                console.log(val);
                this.th = val;
            },
        },
        methods:{
            init(){
                const start= new Date();
                const end=new Date(start.getTime() + 1000 * 60 * 60 * 24 * 30);
                this.datetimerangeValue=[start, end];
                this.getList();
            },
            getMenu(){
                let list = JSON.parse(window.localStorage.getItem("listMenuDTO"));
                var menu = getMenuButton(list,this.$route.path);
                this.menuButtonList = JSON.stringify(menu);
                if(menu!=null&&menu.length>0){
                    for(let i=0;i<menu.length;i++){
                        if(menu[i].buttonName=="添加"){
                            this.disabledAdd = false;
                        }
                    }
                }
            },
            rowClick(row){
                this.row=row;
                if(this.menuButtonList.indexOf("编辑")!=-1){
                    this.disabledEdit =false;
                }
                
            },
            getTime(row){
                return timefilters(row.time).slice(0,10)
            },
            openAdd(data){
                this.closeAdd()
                this.$refs.myAdd.init(data);
            },
            getList(){
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"MedicationScheduling/Page",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        elderlyName:this.elderlyName,
                        status:this.status-1,
                        startTime:this.startTime,
                        endTime:this.endTime,
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                    }
                }).then( (response)=> {
                    this.disabledEdit = true;
                    if(response.data.error == 0){
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                    }else if(response.data.error == 1){
                        this.$message({type: 'info', message: response.data.message});
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },

            handleGetElderly(index, row) {
                this.$refs.myGetElderly.init(row);
                this.showModalGetElderly = !this.showModalGetElderly;
            },
            handleEdit() {
                this.$refs.myEdit.init(this.row);
                this.showModalEdit = !this.showModalEdit;
            },
            toggleModalAdd:function(){
                this.showModalGetElderly = !this.showModalGetElderly;
                this.$refs.myGetElderly.init();
            },
            closeAdd:function(){
                this.showModalAdd = !this.showModalAdd;
            },
            toggleModalGetElderly:function(){
                this.showModalGetElderly = !this.showModalGetElderly;
            },
            closeGetElderly:function(){
                this.showModalGetElderly = !this.showModalGetElderly;
            },

            closeEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },

            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.init();
            },
            formatTime:function (row, column, cellValue) {
                return timefilters(cellValue);
            },
            statusTitle(row){
                if(row.status == 0){
                    return "正常";
                }
                if(row.status == 1){
                    return "禁用";
                }
                return "其它";
            },

        }
    }
</script>
<style>
    .demo-table-expand {
        font-size: 0;
    }

    .demo-table-expand label {
        /* width: 100%; */
        color: #99a9bf;
    }

    .demo-table-expand .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
        width: 50%;
    }
</style>
<style lang="scss" scoped>
    /deep/ .el-table__body tr.current-row>td {
        background-color: #409EFF;
        color:#fff;
    }

</style>